/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Helmet } from 'react-helmet';

import sunburst from './images/sunburst.svg';
import settings from './images/settings.svg';
import ConfettiImg from './images/confetti.svg';
import close from './images/close.svg';
// import logo from './images/logo.svg';
import logo from './images/Logo-Event.png';
import spin from './images/spin.svg';
import spinHover from './images/spin-hover.svg';
import arrowSpin from './images/element-arrow.svg';
import lanternRight from './images/BG-botton.png';
import lanternRightSmall from './images/BG-Top.png';

import techx from './images/techx.svg';
import confetti from 'canvas-confetti';
import Slot from '../../Slot';
import SoundEffects from '../../SoundEffects';
import DigitSlotMachine from '../../components/DigitSlotMachine';
import './style.css';

function TX2years(): JSX.Element {
  const [remain, setRemain] = useState<any>(null);
  const [popup, setPopup] = useState(false);
  const [numberGroupWinner, setNumberGroupWinner] = useState(1);
  const [winner, setWinner] = useState<any>(null);
  const [currentDisplayValue, setCurrentDisplayValue] = useState<string>('');
  const [isDigitSpinning, setIsDigitSpinning] = useState(false);
  const [digitCount, setDigitCount] = useState<number>(6); // Number of digits to display
  const [spinDurationPerDigit, setSpinDurationPerDigit] = useState<number>(2500); // Spin duration per digit in ms

  // Sequential prize draw states
  const [currentPrizeIndex, setCurrentPrizeIndex] = useState<number>(0); // 0-based index
  const [revealedWinners, setRevealedWinners] = useState<string[]>([]); // Winners already revealed
  const [isDrawingSession, setIsDrawingSession] = useState<boolean>(false); // Whether we're in a multi-prize session
  const [isAutoMode, setIsAutoMode] = useState<boolean>(true); // Auto spin next prize
  const [autoModeDelay, setAutoModeDelay] = useState<number>(2000); // Delay between auto spins in ms

  const numberGroupWinnerRef: any = useRef(null);
  const digitCountRef = useRef<HTMLSelectElement>(null);
  const spinDurationRef = useRef<HTMLSelectElement>(null);
  const autoModeRef = useRef<HTMLInputElement>(null);
  const autoModeDelayRef = useRef<HTMLSelectElement>(null);
  const soundEffectsRef = useRef<SoundEffects | null>(null);
  const slotRef = useRef<Slot | null>(null);

  // Helper function to pad number with leading zeros
  const padNumber = (num: string, length: number): string => {
    return num.padStart(length, '0');
  };
  useEffect(() => {
    const drawButton = document.getElementById('draw-button') as HTMLButtonElement | null;
    const drawButtonHover = document.getElementById(
      'draw-button-hover'
    ) as HTMLButtonElement | null;
    const settingsButton = document.getElementById('settings-button') as HTMLButtonElement | null;
    const settingsWrapper = document.getElementById('settings') as HTMLDivElement | null;
    const settingsContent = document.getElementById('settings-panel') as HTMLDivElement | null;
    const settingsSaveButton = document.getElementById('settings-save') as HTMLButtonElement | null;
    const settingsCloseButton = document.getElementById(
      'settings-close'
    ) as HTMLButtonElement | null;
    const sunburstSvg = document.getElementById('sunburst') as HTMLImageElement | null;
    const confettiCanvas = document.getElementById('confetti-canvas') as HTMLCanvasElement | null;
    const nameListTextArea = document.getElementById('name-list') as HTMLTextAreaElement | null;
    const removeNameFromListCheckbox = document.getElementById(
      'remove-from-list'
    ) as HTMLInputElement | null;
    const enableSoundCheckbox = document.getElementById('enable-sound') as HTMLInputElement | null;

    // Graceful exit if necessary elements are not found
    if (
      !(
        drawButton &&
        drawButtonHover &&
        settingsButton &&
        settingsWrapper &&
        settingsContent &&
        settingsSaveButton &&
        settingsCloseButton &&
        sunburstSvg &&
        confettiCanvas &&
        nameListTextArea &&
        removeNameFromListCheckbox &&
        enableSoundCheckbox
      )
    ) {
      console.error('One or more Element ID is invalid. This is possibly a bug.');
      return;
    }

    if (!(confettiCanvas instanceof HTMLCanvasElement)) {
      console.error('Confetti canvas is not an instance of Canvas. This is possibly a bug.');
      return;
    }
    const soundEffects = new SoundEffects();
    soundEffectsRef.current = soundEffects;
    const MAX_REEL_ITEMS = 24;
    const CONFETTI_COLORS = ['#F7E494', '#8433cc', '#faff07', '#00c4f3', '#fa0c0c'];
    let confettiAnimationId: number;

    /** Confeetti animation instance */
    const customConfetti = confetti.create(confettiCanvas, {
      resize: true,
      useWorker: true,
    });

    /** Triggers cconfeetti animation until animation is canceled */
    const confettiAnimation = (): void => {
      const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.getElementsByTagName('body')[0].clientWidth;
      const confettiScale = Math.max(0.5, Math.min(1, windowWidth / 1100));

      customConfetti({
        particleCount: 10,
        gravity: 0.8,
        spread: 90,
        origin: { y: 0.6 },
        colors: [CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)]],
        scalar: confettiScale,
      });

      confettiAnimationId = window.requestAnimationFrame(confettiAnimation);
    };

    /** Function to stop the winning animation */
    const stopWinningAnimation = (): void => {
      if (confettiAnimationId) {
        window.cancelAnimationFrame(confettiAnimationId);
      }
      sunburstSvg.style.display = 'none';
    };

    /**  Function to be trigger before spinning - start digit animation immediately */
    const onSpinStart = (): void => {
      stopWinningAnimation();
      drawButton.disabled = true;
      drawButtonHover.disabled = true;
      settingsButton.disabled = true;
      // Spin sound is now handled per-digit in DigitSlotMachine component
      // Start digit spinning animation
      setIsDigitSpinning(true);
    };

    /**  Functions to be trigger after digit animations complete */
    const onDigitAnimationsComplete = async (): Promise<void> => {
      confettiAnimation();
      sunburstSvg.style.display = 'block';
      await soundEffects.win();
      setIsDigitSpinning(false);

      // Add current winner to revealed winners
      setRevealedWinners((prev) => {
        const newRevealed = [...prev, (window as any).__currentWinner || ''];
        const totalPrizes = numberGroupWinnerRef.current
          ? parseInt(numberGroupWinnerRef.current.value)
          : 1;

        // Check if all prizes are revealed
        if (newRevealed.length >= totalPrizes) {
          // All prizes revealed - show final popup
          setPopup(true);
          setWinner(newRevealed);
          setIsDrawingSession(false);
          setCurrentPrizeIndex(0);
          drawButton.disabled = false;
          drawButtonHover.disabled = false;
          settingsButton.disabled = false;
        } else {
          // More prizes to go
          setCurrentPrizeIndex(newRevealed.length);

          // Check auto mode
          const isAuto = autoModeRef.current?.checked ?? true;
          const delay = autoModeDelayRef.current ? parseInt(autoModeDelayRef.current.value) : 2000;

          if (isAuto) {
            // Auto spin next prize after delay
            setTimeout(() => {
              if (slotRef.current && slotRef.current.names.length > 0) {
                slotRef.current.spin();
              }
            }, delay);
          } else {
            // Manual mode - enable button for next spin
            drawButton.disabled = false;
            drawButtonHover.disabled = false;
          }
        }

        return newRevealed;
      });
    };

    // Store the callback for use in the component
    (window as any).__onDigitAnimationsComplete = onDigitAnimationsComplete;

    /**  Functions to be trigger after spinning - winner is now set */
    const onSpinEnd = async (): Promise<void> => {
      // Winner is set, digit animation is already running from onSpinStart
      // The animation will complete via onDigitAnimationsComplete
    };

    /**  Function to be trigger before spinning */

    /** Slot instance */
    const slot = new Slot({
      reelContainerSelector: '#reel',
      maxReelItems: MAX_REEL_ITEMS,
      onSpinStart,
      onSpinEnd,
      onNameListChanged: stopWinningAnimation,
      onSetWinner: (winners: string[]) => {
        // For sequential mode, we only get 1 winner at a time
        if (winners.length > 0) {
          const currentWinner = winners[0];
          setCurrentDisplayValue(currentWinner);
          // Store current winner for callback
          (window as any).__currentWinner = currentWinner;
        }
      },
      onSetRemain: (remainNum: number) => setRemain(remainNum),
    });

    // Store slot reference for auto-spin
    slotRef.current = slot;

    /** To open the setting page */
    const onSettingsOpen = (): void => {
      nameListTextArea.value = slot.names.length ? slot.names.join('\n') : '';
      removeNameFromListCheckbox.checked = slot.shouldRemoveWinnerFromNameList;
      enableSoundCheckbox.checked = !soundEffects.mute;
      settingsWrapper.style.display = 'block';
    };

    /** To close the setting page */
    const onSettingsClose = (): void => {
      settingsContent.scrollTop = 0;
      settingsWrapper.style.display = 'none';
    };

    // Helper function to start a new drawing session
    const startDrawSession = (): void => {
      if (!slot.names.length) {
        onSettingsOpen();
        return;
      }

      const totalPrizes = numberGroupWinnerRef.current
        ? parseInt(numberGroupWinnerRef.current.value)
        : 1;

      // Reset session states
      setRevealedWinners([]);
      setCurrentPrizeIndex(0);
      setIsDrawingSession(totalPrizes > 1);
      setPopup(false);

      // For sequential mode, always draw 1 winner at a time
      slot.setNumberGroupWinner = 1;

      slot.spin();
    };

    // Click handler for "Draw" button
    drawButton.addEventListener('click', startDrawSession);
    drawButtonHover.addEventListener('click', startDrawSession);

    // Hide fullscreen button when it is not supported
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - for older browsers support

    // Click handler for "Settings" button
    settingsButton.addEventListener('click', onSettingsOpen);

    // Click handler for "Save" button for setting page
    settingsSaveButton.addEventListener('click', () => {
      // Get the selected digit count
      const selectedDigitCount = digitCountRef.current ? parseInt(digitCountRef.current.value) : 3;
      setDigitCount(selectedDigitCount);

      // Get the selected spin duration
      const selectedSpinDuration = spinDurationRef.current
        ? parseInt(spinDurationRef.current.value)
        : 2500;
      setSpinDurationPerDigit(selectedSpinDuration);

      // Get auto mode settings
      const selectedAutoMode = autoModeRef.current?.checked ?? true;
      setIsAutoMode(selectedAutoMode);

      const selectedAutoModeDelay = autoModeDelayRef.current
        ? parseInt(autoModeDelayRef.current.value)
        : 2000;
      setAutoModeDelay(selectedAutoModeDelay);

      // Process names and pad with leading zeros
      const rawNames = nameListTextArea.value
        ? nameListTextArea.value.split(/\n/).filter((name) => Boolean(name.trim()))
        : [];

      // Pad each name/number with leading zeros to match digit count
      slot.names = rawNames.map((name) => padNumber(name.trim(), selectedDigitCount));

      slot.shouldRemoveWinnerFromNameList = removeNameFromListCheckbox.checked;
      // Don't set numberGroupWinner here - it's managed by startDrawSession
      setNumberGroupWinner(parseInt(numberGroupWinnerRef.current.value));

      soundEffects.mute = !enableSoundCheckbox.checked;
      onSettingsClose();
    });

    // Click handler for "Discard and close" button for setting page
    settingsCloseButton.addEventListener('click', onSettingsClose);
  }, []);

  const handleClick = (): void => {
    setPopup(false);
  };

  // Handler for when all digit animations complete
  const handleDigitAnimationsComplete = useCallback(() => {
    const callback = (window as any).__onDigitAnimationsComplete;
    if (callback) {
      callback();
    }
  }, []);

  return (
    <div id="chinese-new-year">
      <Helmet>
        <title>SCB TechX Lucky Draw</title>
      </Helmet>
      {popup && (
        <div id="popup">
          <button className="top-right" onClick={handleClick}></button>
          <div className="centered" style={{ color: 'black' }}>
            {winner && (
              <div
                className={
                  winner.length > 6
                    ? 'winner-grid winner-grid--3-col'
                    : winner.length > 2
                    ? 'winner-grid winner-grid--2-col'
                    : ''
                }
              >
                {winner.map((data: any, index: number) => (
                  <div key={`${data}-${index}`} className="winner-grid__item">
                    {data}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      <canvas className="confetti" id="confetti-canvas"></canvas>

      <div className={`theme--red ${popup === true ? 'popup' : ''}`} id="app">
        <div className="main">
          <div className="snowflakes" aria-hidden="true">
            <div className="snowflake c1">
              <img src={ConfettiImg} alt="confetti" />
            </div>
            <div className="snowflake c2">
              <img src={ConfettiImg} alt="settings" />
            </div>

            <div className="snowflake c3">
              <img src={ConfettiImg} alt="settings" />
            </div>

            <div className="snowflake c4">
              <img src={ConfettiImg} alt="settings" />
            </div>

            <div className="snowflake c5">
              <img src={ConfettiImg} alt="settings" />
            </div>

            <div className="snowflake c6">
              <img src={ConfettiImg} alt="settings" />
            </div>

            <div className="snowflake c7">
              <img src={ConfettiImg} alt="settings" />
            </div>
            <div className="snowflake c8">
              <img src={ConfettiImg} alt="settings" />
            </div>
            <div className="snowflake c9">
              <img src={ConfettiImg} alt="settings" />
            </div>
            <div className="snowflake c10">
              <img src={ConfettiImg} alt="settings" />
            </div>
          </div>
          <div className="control-left">
            <div>
              <img id="logo-techx" src={techx} alt="logo" />
              <div className="year-text">2026</div>
            </div>
            <div className="group-text">
              <div className="remaining-text">
                {remain > 0 && (
                  <span>
                    {remain}
                    <span className="triangle"></span>
                    <p className="challengers-text">PARTICIPANTS LEFT</p>
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="control-group">
            <button className="icon-button icon-button--small" id="settings-button">
              <img src={settings} alt="settings" />
            </button>
          </div>
          <div className="control-right-lantern-small">
            <img id="lantern-right-small" src={lanternRightSmall} alt="logo" />
          </div>

          <div id="lucky-draw">
            {/* Show logo OR Prize Progress Indicator (not both) */}
            {numberGroupWinner > 1 && isDrawingSession ? (
              <div className="prize-progress">
                <span className="prize-progress__emoji">🎁</span>
                <div className="prize-progress__box">
                  <span className="prize-progress__label">PRIZE</span>
                  <span className="prize-progress__current">{currentPrizeIndex + 1}</span>
                  <span className="prize-progress__separator">/</span>
                  <span className="prize-progress__total">{numberGroupWinner}</span>
                </div>
                <span className="prize-progress__emoji">🎉</span>
              </div>
            ) : (
              <img src={logo} alt="logo" />
            )}

            <div className="slot">
              <div className="slot__outer">
                <div className="slot__inner">
                  <div className="slot__shadow"></div>
                  {/* Hidden reel for Slot class compatibility */}
                  <div className="reel" id="reel" style={{ display: 'none' }}></div>
                  {/* New Digit Slot Machine */}
                  <DigitSlotMachine
                    value={currentDisplayValue || 'X'.repeat(digitCount)}
                    isSpinning={isDigitSpinning}
                    onAllAnimationsComplete={handleDigitAnimationsComplete}
                    spinDurationPerDigit={spinDurationPerDigit}
                    soundEffects={soundEffectsRef.current}
                    digitStopSound="ding"
                  />
                </div>
              </div>

              <div className="sunburst" id="sunburst">
                <img src={sunburst} alt="sunburst" />
              </div>
            </div>

            <div
              className={`btn-spin ${
                isDigitSpinning || (isDrawingSession && isAutoMode) ? 'disabled' : ''
              }`}
              style={{
                opacity: isDigitSpinning || (isDrawingSession && isAutoMode) ? 0.5 : 1,
                pointerEvents:
                  isDigitSpinning || (isDrawingSession && isAutoMode) ? 'none' : 'auto',
                filter:
                  isDigitSpinning || (isDrawingSession && isAutoMode) ? 'grayscale(50%)' : 'none',
              }}
            >
              <img className="spin" src={spin} alt="spin" id="draw-button" />
              <img className="spin-hover" src={spinHover} alt="spin-hover" id="draw-button-hover" />
            </div>
            {/* Revealed Winners Panel */}
            {numberGroupWinner > 1 && revealedWinners.length > 0 && (
              <div className="revealed-winners__list">
                {revealedWinners.map((w, idx) => (
                  <React.Fragment key={`revealed-${idx}`}>
                    <div className="revealed-winners__item">
                      <span className="revealed-winners__index">#{idx + 1}</span>
                      <span className="revealed-winners__number">{w}</span>
                    </div>
                    {(idx + 1) % 6 === 0 && idx + 1 !== revealedWinners.length && (
                      <div className="revealed-winners__break" />
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <div className="settings" id="settings">
            <div className="settings__panel" id="settings-panel">
              <div className="settings__panel__group">
                <div className="group-header">
                  <h1 className="settings__title">Settings</h1>
                  <button className="solid-button solid-button" id="settings-save">
                    Save
                  </button>
                </div>
                <h2 className="prizes-text">Prizes</h2>
                <select
                  className="styled-option"
                  name="optionDate"
                  ref={numberGroupWinnerRef}
                  value={numberGroupWinner}
                  onChange={(e) => setNumberGroupWinner(parseInt(e.target.value))}
                >
                  <option key={`1`} value={1}>
                    1
                  </option>
                  <option key={`2`} value={2}>
                    2
                  </option>

                  <option key={`3`} value={3}>
                    3
                  </option>

                  <option key={`4`} value={4}>
                    4
                  </option>
                  <option key={`5`} value={5}>
                    5
                  </option>
                  <option key={`10`} value={10}>
                    10
                  </option>
                  <option key={`11`} value={11}>
                    11
                  </option>
                </select>

                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="digit-count">
                    Number of Digits
                  </label>
                  <select
                    className="styled-option"
                    id="digit-count"
                    ref={digitCountRef}
                    value={digitCount}
                    onChange={(e) => setDigitCount(parseInt(e.target.value))}
                  >
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                  </select>
                </div>

                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="spin-duration">
                    Spin Duration (per digit)
                  </label>
                  <select
                    className="styled-option"
                    id="spin-duration"
                    ref={spinDurationRef}
                    value={spinDurationPerDigit}
                    onChange={(e) => setSpinDurationPerDigit(parseInt(e.target.value))}
                  >
                    <option value={1000}>1 second</option>
                    <option value={1500}>1.5 seconds</option>
                    <option value={2000}>2 seconds</option>
                    <option value={2500}>2.5 seconds</option>
                    <option value={3000}>3 seconds</option>
                    <option value={3500}>3.5 seconds</option>
                    <option value={4000}>4 seconds</option>
                  </select>
                </div>

                <div className="input-group">
                  <div className="group-challengers">
                    <label className="input-label" htmlFor="name-list" id="challengers-text">
                      Challengers
                    </label>
                    <div id="remaining-text" style={{ color: 'white' }}>
                      {remain > 0 && <h3>{remain} Left</h3>}
                    </div>
                  </div>
                  <textarea
                    className="input-field input-field--textarea"
                    rows={8}
                    placeholder="Separate each name by line break"
                    id="name-list"
                  ></textarea>
                </div>
                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="remove-from-list">
                    Remove winner from list
                  </label>
                  <label className="input--switch" aria-label="Remove winner from list toggle">
                    <input type="checkbox" id="remove-from-list" />

                    <span className="slider"></span>
                  </label>
                </div>
                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="enable-sound">
                    Enable sound effect
                  </label>
                  <label className="input--switch" aria-label="Enable sound effect toggle">
                    <input type="checkbox" id="enable-sound" />
                    <span className="slider"></span>
                  </label>
                </div>

                {/* Auto Mode Settings - only show when multiple prizes */}
                <div className="settings__section-title">Multi-Prize Settings</div>
                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="auto-mode">
                    Auto spin next prize
                  </label>
                  <label className="input--switch" aria-label="Auto spin toggle">
                    <input
                      type="checkbox"
                      id="auto-mode"
                      ref={autoModeRef}
                      defaultChecked={isAutoMode}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
                <div className="input-group input-group--2-column">
                  <label className="input-label" htmlFor="auto-mode-delay">
                    Delay between prizes
                  </label>
                  <select
                    className="styled-option"
                    id="auto-mode-delay"
                    ref={autoModeDelayRef}
                    value={autoModeDelay}
                    onChange={(e) => setAutoModeDelay(parseInt(e.target.value))}
                  >
                    <option value={1000}>1 second</option>
                    <option value={1500}>1.5 seconds</option>
                    <option value={2000}>2 seconds</option>
                    <option value={2500}>2.5 seconds</option>
                    <option value={3000}>3 seconds</option>
                    <option value={4000}>4 seconds</option>
                    <option value={5000}>5 seconds</option>
                  </select>
                </div>
              </div>
              <div className="settings__panel__group">
                <button className="solid-button solid-button--danger" id="settings-close">
                  Discard and close
                </button>
              </div>
            </div>
          </div>
          <div className="control-footer">
            <img id="bg" src={lanternRight} alt="bg-center-wide" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TX2years;
